<template>
  <div>
      <header id="dashboard-header" class="">
        <div>
          <a class="btn-menu-header" @click="movimentarMenuPrincipal()">
            <SGPIconComponent icon="mdi-menu"></SGPIconComponent>
          </a>
          <router-link to="/workflow/backlog">
            <img class="mdn-logoSvg" src="@/assets/modosWeb.png" width="170" alt="Logo da Claro">
          </router-link>
        </div>

        <div class="header-actions">

          <ModuleSwitcherComponent :compact="$vuetify.breakpoint.smAndDown" />
          
          <div class="div-separator"></div>

          <NotificacaoHeaderComponent />
            <v-menu
              open-on-hover
              bottom
              offset-y
            >
            <template v-slot:activator="{ on, attrs }">
              <button
                v-bind="attrs"
                v-on="on"
              >
                <SGPIconComponent large class="btn-portal-header" color="white" icon="mdi-account"></SGPIconComponent>
              </button>
            </template>
              <v-list dense>
                <v-list-item  class="cursor-pointer" @click="meuPerfil">
                  <v-list-item-icon x-small>
                    <SGPIconComponent icon="mdi-account"></SGPIconComponent>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Dados do usuário</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item  class="cursor-pointer" @click="deslogarUsuario">
                  <v-list-item-icon x-small>
                    <SGPIconComponent icon="mdi-logout-variant"></SGPIconComponent>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Sair do sistema</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
    </header>
    <div class="subheader" v-if="exibirBemVindoAposLogin">
      <SGPColComponent cols-9>
        <p style="margin: 5px;">
          <strong>Bem-vindo ao Modos Web, <span style="color: #F72126;">{{ nomeUsuarioBemVindo }}</span></strong>
        </p>
      </SGPColComponent>
      <SGPColComponent cols-3>
        <p class="logos">
          <img class="logo-claro" width="50" src="@/assets/claro-mondrian-logo.png" />
        </p>
      </SGPColComponent>
    </div>
  </div>

</template>

<script>

import { mapActions, mapGetters } from "vuex";
import ModuleSwitcherComponent from '@/modules/app/ctrl-modulos/components/ModuleSwitcherComponent.vue';
import NotificacaoHeaderComponent from "./NotificacaoHeaderComponent.vue";

const BEM_VINDO_APOS_LOGIN_KEY = 'modos-web-mostrar-bem-vindo'
const BEM_VINDO_DURACAO_MS = 8000

export default {
  name: "DashboardHeaderComponent",

  components: {
    ModuleSwitcherComponent,
    NotificacaoHeaderComponent
  },

  data () {
    return {
      nomeUsuario: '',
      exibirBemVindoAposLogin: false,
      bemVindoTimeoutId: null,
    }
  },

  created() {
    this.sincronizarBemVindoAposLogin()
  },

  computed: {
    ...mapGetters('login', ['usuarioLogado']),

    nomeUsuarioBemVindo() {
      const u = this.usuarioLogado || {}
      return u.nome || u.name || ''
    },

    nomeAvatar() {
      const nome = this.usuarioLogado.nome.split(' ');
      const primeiroNome = nome[0]
      let ultimoNome = nome[nome.length - 1]

      if (nome.length == 1) {
        ultimoNome = primeiroNome[1]
      }

      return `${primeiroNome[0]}${ultimoNome[0]}`;
    },

    roleUsuarioLogado() {
      try {
        const usuarioStorage = JSON.parse(localStorage.getItem("provedores-usuario"));
        if (usuarioStorage && usuarioStorage.roles && usuarioStorage.roles.length > 0) {
          const role = usuarioStorage.roles.find(role => role.name.toLowerCase() === 'administrador');
          return role ? role.name : null;
        }
        return null;
      } catch (error) {
        return null;
      }
    }
  },

  methods: {
    limparTimerBemVindo() {
      if (this.bemVindoTimeoutId) {
        clearTimeout(this.bemVindoTimeoutId)
        this.bemVindoTimeoutId = null
      }
    },

    sincronizarBemVindoAposLogin() {
      this.limparTimerBemVindo()
      if (this.$route.path !== '/workflow/backlog') {
        this.exibirBemVindoAposLogin = false
        return
      }
      if (sessionStorage.getItem(BEM_VINDO_APOS_LOGIN_KEY) === '1') {
        sessionStorage.removeItem(BEM_VINDO_APOS_LOGIN_KEY)
        this.exibirBemVindoAposLogin = true
        this.bemVindoTimeoutId = setTimeout(() => {
          this.exibirBemVindoAposLogin = false
          this.bemVindoTimeoutId = null
        }, BEM_VINDO_DURACAO_MS)
      } else {
        this.exibirBemVindoAposLogin = false
      }
    },

    movimentarMenuPrincipal() {
      this.$emit("gerenciarMenu");
    },
    ...mapActions("login", ["deslogarUsuario"]),

    meuPerfil() {
      let route = this.$router.resolve({ path: '/app/usuarios/' + this.usuarioLogado.id + '/meu-perfil' });
      window.open(route.href);
    },

    abrirPowerBI() {
      window.open('https://app.powerbi.com/reportEmbed?reportId=ceb97d6b-d47c-481c-9812-a6b09214d81c&autoAuth=true&ctid=55247d4b-b435-47a5-881b-ca7627434e79', '_blank');
    },

    portalSolicitacoes() {
      // let route = this.$router.resolve({ path: '/sgp/portal-solicitacoes'});
      // window.open(route.href);
    },
  },
  watch: {
    '$route'() {
      this.sincronizarBemVindoAposLogin()
    }
  },

  beforeDestroy() {
    this.limparTimerBemVindo()
  }
};
</script>

<style scoped>
.btn-portal-header {
  font-size: 22px;
  font-weight: bold;
  color: #fff;
  padding: 5px 6px;
  margin: 0;
  border-radius: 50%;
  width: 50px;
}

.btn-powerbi-header {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
}

.link-documentos-processos {
  text-decoration: none;
  color: #000;
}

.div-separator {
  border: 1px solid white;
  height: 30px;
  margin: 10px;
}

.subheader {
  margin: 0;
  position: relative !important;
  width: 100% !important;
  top: 50px;
  z-index: 0;
  background-color: #eee;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0%;
}

.logos {
  text-align: right;
  background: #eee;
  margin: 0;
}

.logo-embratel {
  width: 120px;
  margin-right: 15px;
}

.logo-claro {
  width: 40px;
}
</style>
